"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var ArrowDown = function ArrowDown(props) {
  return _react["default"].createElement("svg", {
    className: props.className,
    width: props.width,
    viewBox: "0 0 12 9",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, _react["default"].createElement("title", null, "Select"), _react["default"].createElement("desc", null, "Chevron symbol inviting you to select"), _react["default"].createElement("g", {
    stroke: "none",
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("g", {
    transform: "translate(-292.000000, -126.000000)",
    fill: props.colour || "#002272",
    fillRule: "nonzero"
  }, _react["default"].createElement("g", {
    transform: "translate(286.000000, 118.000000)"
  }, _react["default"].createElement("polygon", {
    points: "7.41 8.84 12 13.42 16.59 8.84 18 10.25 12 16.25 6 10.25"
  })))));
};

var _default = ArrowDown;
exports["default"] = _default;